const SORT_ORDERS = ["ascend", "descend"];

export const getOrderBy = (sorter) => {
  const { order, column: { key, dataIndex } = {} } = sorter || {};
  const canOrderBy = order && (key || dataIndex) && SORT_ORDERS.includes(order);

  if (canOrderBy) {
    return {
      orderBy: [`${key || dataIndex} ${order === "ascend" ? "asc" : "desc"}`],
    };
  }

  return { orderBy: [] };
};
